// extracted by mini-css-extract-plugin
export var linkText = "_ph-0";